import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
export default class HowProductWorks {
    static $element = $('.js__how-product-works');
    static $pin = $('.js__how-product-works-pin');
    static $progressBars = $('.js__how-product-works-progress-bar');
    static $scenes = $('.js__how-product-works-scene');
    static scene;
    static currentScene;
    static init() {
        if (!this.$element.length) {
            return;
        }
        const controller = new ScrollMagic.Controller({
            globalSceneOptions: {
                triggerHook: 'onLeave',
                duration: `${this.$scenes.length * 100}%`,
            },
        });
        this.scene = new ScrollMagic.Scene({
            triggerElement: this.$element.get(0),
        })
            .setPin(this.$pin.get(0))
            .addTo(controller);
        this.scene.on('enter', (event) => {
            const nextScene = this.getCurrentSceneByProgress(event.progress);
            this.$element.addClass('active');
            this.sceneChange(nextScene);
        });
        this.scene.on('leave', (event) => {
            this.$element.removeClass('active');
            this.$scenes.removeClass('active');
            if (event.progress === 0) {
                this.$progressBars.removeClass('active');
            }
        });
        this.scene.on('progress', (event) => {
            const nextScene = this.getCurrentSceneByProgress(event.progress);
            if (this.currentScene !== nextScene) {
                this.sceneChange(nextScene);
            }
        });
    }
    static sceneChange(nextScene) {
        this.currentScene = nextScene;
        this.$scenes.removeClass('active').eq(this.currentScene).addClass('active');
        this.$progressBars
            .removeClass('active')
            .slice(0, this.currentScene + 1)
            .addClass('active');
    }
    static getCurrentSceneByProgress(progress) {
        return Math.min(Math.floor(progress * this.$scenes.length), this.$scenes.length - 1);
    }
}
